import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (ids) => {
    const { data, error } = await supabase
        .from('service_pricing_duration')
        .select(`*, services(*)`)
        .in("service", ids)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllServicePricingDurationByServiceIn(ids) {
    return useQuery({
        queryKey: ['useGetAllServicePricingDurationByService',ids],
        queryFn: () => getServices(ids),
        staleTime: 0,
        enabled: !!ids
    })
}
